import React from 'react'
import { LinkButton } from '@/atoms/Button'
import { PayItForwardIcon } from '@/atoms/Icons/PayItForwardIcon'
import { ParagraphSM, TitleSM } from '@/atoms/Text'
import { paths, slugs } from '@/constants'
import { ProjectDetails } from '@/services/ProjectsService'
import { useTranslate } from '@/utils/translate/translate-client'

interface PayItForwardSectionProps {
  onClick?: () => void
  project: ProjectDetails
}

const generateLink = (slug: string, pifEnabled: boolean) => {
  let result = {
    link: '',
    external: false,
  }

  switch (slug) {
    case slugs.david:
      result = { link: 'https://shop.angel.com/products/pay-it-forward-david%E2%84%A2', external: true }
      break
    default:
      result.link = pifEnabled
        ? `${paths.payItForward.index}/${slug}`
        : `${paths.payItForward.index}/for-your-consideration`
      break
  }

  return result
}

export const PayItForwardSection: React.FC<PayItForwardSectionProps> = ({ onClick, project }) => {
  const { t } = useTranslate('pif')
  const { link, external } = generateLink(project.slug, project.pifEnabled)

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-100 p-6 lg:p-12">
      <div className="flex w-full flex-col gap-4 md:gap-6">
        <div className="flex items-center gap-3 align-middle">
          <div className="flex h-10 w-10 rounded-3xl bg-oxide-primary align-middle">
            <PayItForwardIcon color="white" className="m-auto" />
          </div>
          <TitleSM weight="bold" className="md:photon-title-md lg:photon-title-lg" color="core-gray-950">
            {t('payItForward', 'Pay it Forward')}.
          </TitleSM>
        </div>
        <ParagraphSM className="md:photon-title-md text-pretty" color="core-gray-800" weight="medium">
          {t(
            'joinOurMissionInfuseIndustryPayItForward',
            'Join our mission to infuse the industry with high-quality, uplifting entertainment the whole family can enjoy.  Not only does Pay it Forward benefit you, but it allows you to amplify light around the globe.',
          )}
        </ParagraphSM>
        <div className="grid grid-cols-2 gap-8 align-middle">
          <LinkButton
            className="w-fit border-0 bg-oxide-primary"
            external={external}
            href={link}
            onClick={onClick}
            variant={'oxide'}
            prefetch={false}
          >
            <div className="mx-auto whitespace-nowrap text-center">Pay it Forward</div>
          </LinkButton>
        </div>
      </div>
    </div>
  )
}
